document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".side-by-side");
  blocks.forEach((block, index) => {
    const image = block.querySelector(".side-by-side-image");

    if (image) {
      ScrollTrigger.create({
        trigger: block,
        start: "-200px center",
        end: "bottom center",
        onEnter: () => {
          // Animate the image
          gsap.to(image, {
            x: 0,
            opacity: 1,
            duration: 2.3,
            ease: "power3.out",
          });
        },
      });
    }
  });
  const elements = document.querySelectorAll(".anim-top");

  elements.forEach((element) => {
    if (element) {
      ScrollTrigger.create({
        trigger: element,
        start: "top 85%", // Adjust this to control when the animation starts
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .to(element, {
              opacity: 1,
              duration: 0.5, // Animate opacity first
              ease: "power3.out",
            })
            .to(
              element,
              {
                y: 0,
                duration: 0.7, // Animate y after opacity
                ease: "power3.out",
              },
              "-=0.3"
            ); // Overlap animations slightly (optional)
        },
      });
    }
  });
});
